import { BaseDto } from "./base.dto";
import { DateOfBirthDto } from "./date-of-birth.dto";
import { FileDto } from "./file.dto";
import { MallDto } from "./mall.dto";
import { TenantDto } from "./tenant.dto";

export class UserDto extends BaseDto {
  fullName: string;
  firstName: string;
  lastName: string;
  city: string;
  oversea: boolean;
  email: string;
  phoneNumber: string;
  gender: string;
  dateOfBirth: DateOfBirthDto;
  enabled: boolean;
  photo: FileDto;
  roleNames: string[];
  mall: MallDto;
  tenant: TenantDto;
  tenantId: string;
  offlineTenantId: string;
  /** When true, Food ordering (F&B) features are enabled for this user/tenant. */
  fnbOrderingEnabled?: boolean;
  mallId: string;
  google: string;
  apple: string;
  facebook: string;
  deletedAt: Date;

  static create() {
    return new UserDto();
  }
}

export enum RoleNames {
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  TENANT = "TENANT",
  MALL = "MALL",
  ACCOUNT = "ACCOUNT",
  SALE = "SALE",
  COUNTER = "COUNTER",
  CUSTOMER_SERVICE = "CUSTOMER_SERVICE",
  TENANT_CONTROL = "TENANT_CONTROL",
  OFFLINE_TENANT_ADMIN = "OFFLINE_TENANT_ADMIN",
  OFFLINE_TENANT_STAFF = "OFFLINE_TENANT_STAFF",
  MALL_SALE = "MALL_SALE",
  ONLINE_TENANT_ADMIN = "ONLINE_TENANT_ADMIN",
  CUSTOMER = "CUSTOMER",
  COUNTER_STAFF = "COUNTER_STAFF",
}

export class CreateUserDto {
  fullName: string;
  email: string;
  password: string;
  roleName: string;
  photoId?: string;

  static create(data: CreateUserDto) {
    return Object.assign(new CreateUserDto(), data);
  }
}
